var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellnesslite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8845 35.0684H21.1155V30.0342H26.1155V25.7748H21.1155V20.7406H16.8845V25.7748H11.8845V30.0342H16.8845V35.0684ZM9.6155 42C8.62117 42 7.77 41.6436 7.062 40.9307C6.354 40.2179 6 39.3609 6 38.3598V17.4487C6 16.4476 6.354 15.5906 7.062 14.8777C7.77 14.1649 8.62117 13.8085 9.6155 13.8085H28.3845C29.3788 13.8085 30.23 14.1649 30.938 14.8777C31.646 15.5906 32 16.4476 32 17.4487V38.3598C32 39.3609 31.646 40.2179 30.938 40.9307C30.23 41.6436 29.3788 42 28.3845 42H9.6155ZM9.6155 38.9795H28.3845C28.5385 38.9795 28.6795 38.915 28.8075 38.7862C28.9358 38.657 29 38.5148 29 38.3598V17.4487C29 17.294 28.9358 17.152 28.8075 17.0228C28.6795 16.8936 28.5385 16.829 28.3845 16.829H9.6155C9.4615 16.829 9.3205 16.8936 9.1925 17.0228C9.06417 17.152 9 17.294 9 17.4487V38.3598C9 38.5148 9.06417 38.657 9.1925 38.7862C9.3205 38.915 9.4615 38.9795 9.6155 38.9795ZM7.4615 11.0205V8H30.5385V11.0205H7.4615Z",
    fill: "#FF000C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 15.875H41.625V16V22.5197L44.2066 19.6154L44.3008 19.5094L44.3942 19.6162L45.0942 20.4178L45.1666 20.5007L45.0934 20.583L41.0934 25.083L41 25.1881L40.9066 25.083L36.9066 20.583L36.8334 20.5007L36.9058 20.4178L37.6058 19.6162L37.6992 19.5094L37.7934 19.6154L40.375 22.5197V16V15.875H40.5H41.5Z",
    fill: "#FF000C",
    stroke: "#FF000C",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 36.125H41.625V36V29.4803L44.2066 32.3846L44.3008 32.4906L44.3942 32.3838L45.0942 31.5822L45.1666 31.4993L45.0934 31.417L41.0934 26.917L41 26.8119L40.9066 26.917L36.9066 31.417L36.8334 31.4993L36.9058 31.5822L37.6058 32.3838L37.6992 32.4906L37.7934 32.3846L40.375 29.4803V36V36.125H40.5H41.5Z",
    fill: "#FF000C",
    stroke: "#FF000C",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnesslite);
export default __webpack_public_path__ + "static/media/Wellness lite.a84b40c71faf8a8d86bbb479ae5e1f15.svg";
export { ForwardRef as ReactComponent };